import styled from 'styled-components';

const Wrapper = styled.section`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 1.75rem;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
  margin-bottom: 1.5rem;

  h5 {
    font-size: 0.8rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 1.25rem;
  }

  .form {
    width: 100%;
    max-width: 100%;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
  }

  .form-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 0.3rem;
    display: block;
  }

  .form-input,
  .form-select {
    height: 38px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    padding: 0 0.875rem;
    font-size: 0.85rem;
    color: #0f172a;
    width: 100%;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    &:focus {
      outline: none;
      border-color: #6366f1;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    }
  }

  .form-row { margin-bottom: 0; }

  .form-center {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 1.25rem;
    row-gap: 0.875rem;
  }

  .btn-block {
    height: 38px;
    align-self: end;
    margin-top: 0.25rem;
    width: 100%;
    border: none;
    border-radius: 9px;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    text-transform: capitalize;
    transition: opacity 0.15s, transform 0.15s;
    &:hover { opacity: 0.9; transform: translateY(-1px); }
  }

  @media (min-width: 768px) {
    .form-center { grid-template-columns: 1fr 1fr; }
  }

  @media (min-width: 992px) {
    .form-center { grid-template-columns: 1fr 1fr 1fr; }
    .btn-block { margin-top: 0; }
  }
`;

export default Wrapper;
